import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-delete-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrl: './delete-confirmation-modal.component.scss'
})
export class DeleteConfirmationModalComponent {
  @Input() countryName: string = '';
  @Input() countryCode: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  confirmDelete() {
    this.activeModal.close('yes');
  }
} 